// src/components/EventMenuComponent.tsx

import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

import {
    IconCalendarEvent,
    IconBus,
    IconUserCog
} from '@tabler/icons-react';

import './MenuComponent.css';


/* =========================================
   TYPES
   ========================================= */

interface EventMenuItem {
    id: number;
    titleEn: string;
    titleDa: string;
    icon: React.ReactNode;
    link: string;
}

interface EventMenuProps {
    eventID?: number;
    itemsToShow?: number[];
}


/* =========================================
   MENU ITEMS
   ========================================= */

const defaultEventMenuItems: EventMenuItem[] = [
    {
        id: 19,
        titleEn: 'Arrivals / Departures',
        titleDa: 'Ankomst/afrejse',
        icon: <IconBus />,
        link: '/admin/transport/overview',

    },

    {
        id: 20,
        titleEn: 'Daily Trips',
        titleDa: 'Dagsture',
        icon: <IconBus />,
        link: '/admin/transport/daily',
    },

    {
        id: 21,
        titleEn: 'Transport Settings',
        titleDa: 'Transport indstillinger',
        icon: <IconUserCog />,
        link: '/admin/transport/settings',
    },

    {
        id: 23,
        titleEn: 'RuteDashboard - Routes',
        titleDa: 'RuteDashboard - Ruter',
        icon: <IconBus />,
        link: '/admin/transport-routes',
    },

    {
        id: 25,
        titleEn: 'RuteDashboard - Bookings',
        titleDa: 'RuteDashboard - Bookinger',
        icon: <IconCalendarEvent />,
        link: '/admin/transport-route/bookings',
    },
];


/* =========================================
   COMPONENT
   ========================================= */

const EventMenuComponent: React.FC<EventMenuProps> = ({
    eventID,
    itemsToShow,
}) => {

    const { language } = useLanguage();

    const filteredMenuItems = itemsToShow
        ? defaultEventMenuItems.filter((item) =>
            itemsToShow.includes(item.id)
        )
        : defaultEventMenuItems;


    return (
        <div className="menu-container">

            <section className="menu-section">

                <div className="menu-section-header">

                    <h2 className="menu-section-title">
                        {language === 'da'
                            ? 'Transport administration'
                            : 'Transport Administration'}
                    </h2>

                    <span className="menu-section-count">
                        {filteredMenuItems.length}
                    </span>

                </div>


                <div className="menu-grid">

                    {filteredMenuItems.map((item) => {

                        const title =
                            language === 'da'
                                ? item.titleDa
                                : item.titleEn;

                        const link = eventID
                            ? `${item.link}/${eventID}`
                            : item.link;


                        return (
                            <Link
                                key={item.id}
                                to={link}
                                className="menu-card"
                            >

                                <div className="menu-card-content">

                                    <div className="menu-icon">
                                        {item.icon}
                                    </div>

                                    <div className="menu-card-text">

                                        <div className="menu-title">
                                            {title}
                                        </div>

                                    </div>

                                </div>

                            </Link>
                        );
                    })}

                </div>

            </section>

        </div>
    );
};

export default EventMenuComponent;